/**
 * @file 地图服务
 * @author fuqiang15
 */

import FormModel from '../BaseFormModel';
import {assign, omit} from 'lodash';

export default class MapServiceFormModel extends FormModel {
    /**
     * @override
     */
    title = '';

    serviceType = 'map';

    formData = {
        appId: '',
        name: '',
        firstLevelIndustry: null,
        secondLevelIndustry: null,
        sync: null
    };

    init() {
        super.init();

        // 地图服务的详情接口是特殊的
        if (this.pageType === 'edit') {
            this.detailRequester = this.api.appServiceMapStoreTableInfo;
        }
        this.publishRequester = this.api.appServicePublish;
    }

    industries = Object.freeze(this.getConstant('INDUSTRIES'));
    industryDatasource = this.industries.map(i => ({label: i.name, value: i.name}));
    yesAndNo = this.getConstantDatasource('YES_AND_NO');

    adaptData(data) {
        data.sync = String(data.sync);
        assign(data, data.row);
        data.name = data.serviceName;
        return super.adaptData(data);
    }

    getDefaultArgs() {
        let serviceId = this.getRouteParams().serviceId;
        return serviceId ? {serviceId} : {};
    }

    prepareData(data) {
        data = super.prepareData(data);
        return this.pageType === 'edit'
            ? omit(data, ['firstLevelIndustry', 'secondLevelIndustry'])
            : data;
    }

    requestPublish() {
        return this.publishRequester({id: this.getRouteParams().serviceId});
    }
}
